import React from 'react';

const PoliticaPrivacidade = props => {
    return (
        <div className="politica aceite cadastro">
            <div className="">
                <h3><b>Política de Privacidade</b></h3>
                <br />

                <p style={{textAlign: 'justify'}}>
                    Esta Política de Privacidade descreve como a LEKA CATÁLOGOS utiliza dados
                    pessoais coletados ou recebidos de Revendedores Leka Catálogos, clientes e visitantes do
                    website. Em particular, esta Política descreve como podemos coletar ou receber seus dados
                    pessoais, os tipos de dados pessoais que podemos coletar, como usamos, compartilhamos e
                    protegemos esses dados, seus direitos e como você pode entrar em contato conosco para
                    obter informações sobre nossas práticas de privacidade.
                </p><br />

                <b>Suas Definições:</b>
                <p style={{textAlign: 'justify'}}>
                    Revendedor(a) Leka Catálogos: Uma pessoa que assinou e teve aceito o Contrato de
                    Revendedor(a) Leka Catálogos. A Revendedor(a) Leka catálogos é independente e comercializa
                    produtos das empresas de venda direta, associadas a Leka Catálogos, em seu próprio nome e
                    por sua própria conta, e não como uma representante comercial, funcionária, agente ou
                    corretora da Leka Catálogos.
                        <br />
                        Cliente: Uma pessoa que adquire produtos Leka Catálogos, mas que não assinou um Contrato
                        de Revendedor(a) Autônoma Leka Catálogos.
                        <br />
                        Visitante: Uma pessoa que não está ligada no site como Revendedor(a) Leka Catálogos ou
                        cliente, mas que está simplesmente visitando o site da web.
                    </p><br />
                <b>1. Como podemos coletar ou receber os dados pessoais</b>
                <p style={{textAlign: 'justify'}}>
                    A Leka Catálogos coleta seus dados pessoais por meio do formulário de registro que você
                    preenche e nos envia, impresso ou eletronicamente, por meio do website da Leka Catálogos,
                    para se tornar uma Revendedor(a) Leka Catálogos, ou por meio das informações fornecidas
                    para adquirir produtos como cliente.
                        <br />
                        Logado como uma Revendedor(a) Leka Catálogos ou cliente. Se estiver logado no site como
                        Leka Catálogos ou Cliente, podemos coletar dados pessoais seus, por exemplo, quando você
                        faz o pedido de produtos e serviços.
                        <br />
                        Cookies. Se estiver logado no site, podemos também usar cookies ou tecnologias semelhantes
                        que coletam determinadas informações de uso do site quando você acessa, consulta ou usa o
                        site. Um cookie é um arquivo de dados gravado no seu computador ou dispositivo móvel
                        quando você visita um site da web usando o mesmo. Cookies podem ser usados para diversos
                        propósitos, inclusive manter o registro de preferências do usuário e as páginas que ele visita
                        dentro de um site da web. Você pode desativar cookies nas configurações do seu navegador
                        (por exemplo, nas "Preferências" ou "Opções da Internet" do seu navegador). Leve em conta,
                        no entanto, que certos recursos do site podem não funcionar corretamente caso você desative
                        o uso de cookies.
                        <br />
                        Entrando em contato conosco. Você também pode optar por nos enviar seus dados pessoais e
                        outras informações através dos diversos canais de comunicação disponibilizados na página
                        “Fale Conosco” do site como, por exemplo, endereços de e-mail da Leka Catálogos, números
                        de telefone e formulários on-line.
                        </p><br />
                <b>2. Os tipos de dados pessoais que podemos coletar</b>
                <p style={{textAlign: 'justify'}}>
                    Se você for um visitante: Por meio dos canais de comunicação disponibilizados na página
                    “Fale Conosco” do site, podemos coletar seus detalhes de contato, tais como nome, endereço
                    de e-mail, endereço postal, número de telefonia fixa e móvel. Você também pode fornecer,
                    voluntariamente, outros dados seus em função de perguntas, dúvidas e comentários.
                    Recomendamos, no entanto, que você não forneça mais dados pessoais seus do que os que
                    forem estritamente necessários para que nós possamos fornecer uma resposta adequada a
                    suas perguntas, dúvidas e comentários. Em especial, não forneça qualquer dado pessoal que
                    revele origem étnica ou racial, opiniões políticas, crenças religiosas ou filosóficas ou
                    participação em sindicatos, nem dados referentes a sua saúde ou vida sexual.
                        </p><br />
                <b>3. Se estiver registrada como Revendedor(a) Leka Catálogos ou Cliente, também podemos
                        coletar:</b>
                <p style={{textAlign: 'justify'}}>
                    - Informações de contato (exemplo: nome, endereço postal ou de e-mail, número de telefonia fixa
                    ou móvel);
                        <br />
                        - Informações organizacionais da Revendedor(a) Leka Catálogos ou Cliente (exemplo: nome
                        da empresa da Revendedor(a) Leka Catálogos, sua profissão e detalhes de propriedade e
                        administração);
                        <br />
                        - Sexo, idade, nacionalidade, data e local de nascimento;
                        <br />
                        - Número de registro da Revendedor(a) Leka Catálogos, nome de usuário e senha;
                        <br />
                        - Número de RG/carteira de identidade nacional, na extensão permitida ou exigida pela
                        legislação aplicável;
                        <br />
                        - Informações de pagamento (exemplo: tais como número da conta bancária ou do cartão de
                        crédito);
                        <br />
                        - Preferências de produtos, hábitos de compras, histórico de compras e comportamento
                        de gastos;
                        <br />
                        - Gerenciar seu registro como Revendedor(a) Leka Catálogos ou Cliente;
                        <br />
                        - Criar e gerar sua conta on-line e responder a suas perguntas e dúvidas;
                        <br />
                        - Processar seus pedidos de produtos e serviços;
                        <br />
                        - Comunicarmo-nos com você para fins de campanhas de relacionamento com o cliente,
                        por meio de e-mails, mensagens via celular ou outros canais que a Leka Catálogos
                        decidir usar (exemplo: sobre produtos ou serviços que oferecermos ou pretendermos oferecer);
                        <br />
                        - Operar, avaliar e melhorar nosso negócio, inclusive: o avaliando sua satisfação com
                        nossas comunicações, materiais, produtos e/ou serviços atuais; o desenvolvendo
                        novos produtos e serviços e determinando a eficácia de nossa publicidade; e o
                        acompanhando e analisando seu uso de produtos, materiais e/ou serviços;
                        <br />
                        - Fornecer seu nome, endereço, número de telefone e endereço de e-mail a outras
                        Revendedor(a)s Leka Catálogos ou membros, tanto de sua linha ascendente quanto do
                        seu grupo de negócios, ou organização de membros;
                        <br />
                        - Facilitar seu uso do site, por meio do uso de cookies (exemplo: para oferecer a
                        funcionalidade de carrinho de compras, para lembrar detalhes de login, preferências de idioma, etc.);
                        <br />
                        - Melhorar o site, inclusive por meio do registro e monitoramento do seu uso do mesmo,
                        empregando cookies, e para diagnosticar problemas com o software e hardware que
                        usamos;
                        <br />
                        - Realizar atividades de contabilização, auditoria, tarifação e cobrança;
                        <br />
                        - Garantir o cumprimento de termos e condições contratuais;
                        - Proteger e prevenir contra fraudes, transações não autorizadas, reclamações e outras
                        responsabilidades civis;
                        - Cumprir os requisitos legais aplicáveis, padrões da indústria e nossas políticas;
                        <br />
                        - Manter o registro de todas suas atividades relacionadas à navegação no site, para
                        melhorar o atendimento e a experiência do cliente.
                        </p><br />
                <b>4. Como usamos os dados pessoais que coletamos em caso de visitantes:</b>
                <p style={{textAlign: 'justify'}}>
                    - Responder a seus comentários, perguntas e dúvidas;
                        <br />
                        - Melhorar o site, inclusive para aperfeiçoar a experiência do usuário e diagnosticar
                        problemas com nossos servidores;
                        <br />
                        - Processar seus pedidos de produtos e serviços;
                        <br />
                        - Manter o registro de todas suas atividades relacionadas à navegação no site, para
                        melhorar o atendimento e a experiência do cliente.
                        </p><br />
                <b>5. Como podemos compartilhar dados pessoais</b>
                <p style={{textAlign: 'justify'}}>
                    A Leka Catálogos não vende, aluga ou negocia seus dados pessoais. A Leka Catálogos pode
                    compartilhar dados pessoais seus somente com:
                        <br />
                        - Entidades dentro do grupo Leka Catálogos ou para quem seja razoavelmente
                        necessário ou desejável que a Leka Catálogos revele dados pessoais;
                        <br />
                        - Terceiros fornecedores de serviços para nos fornecer determinados serviços como, por
                        exemplo, fornecedores de serviços de TI (tais terceiros fornecedores de serviços não têm
                        permissão de usar dados pessoais seus para fins próprios);
                        <br />
                        - Autoridades governamentais e outros terceiros, se exigido por lei ou for razoavelmente
                        necessário para proteger os direitos, propriedade e segurança nossos ou de terceiros.
                        </p><br />
                <b>6. Como protegemos dados pessoais</b>
                <p style={{textAlign: 'justify'}}>
                    Mantemos salvaguardas de segurança técnicas e organizacionais apropriadas, criadas para
                    proteger os dados pessoais que você fornecer contra destruição, perda, alteração, acesso,
                    divulgação ou uso acidental, ilegal ou não autorizado.
                        </p><br />
                <b>7. Links para outros sites da web</b>
                <p style={{textAlign: 'justify'}}>
                    O site pode incluir links para sites da web mantidos por terceiros, cujas práticas de privacidade
                    e uso de informações sejam diferentes das nossas. Não temos responsabilidade pelas práticas
                    de privacidade e uso de informações empregadas por esses terceiros. Recomendamos que
                    você leia as declarações de privacidade de qualquer site da web antes de usá-lo ou submeter
                    qualquer dado pessoal ou qualquer outra informação no site ou por meio dele.
                        </p><br />
                <b>8. Atualizações desta Política de Privacidade</b>
                <p style={{textAlign: 'justify'}}>
                    A Leka Catálogos pode atualizar esta Política de Privacidade periodicamente. Nós o
                    informaremos de qualquer alteração significativa desta Política de Privacidade em website
                    oficial da Leka Catálogos ou por meio de outros canais de comunicação apropriados. Todas as
                    alterações entram em vigor na data de sua publicação, exceto se o contrário for informado no
                    aviso.
                        </p><br />
                <b>9. Seus direitos</b>
                <p style={{textAlign: 'justify'}}>
                    Seus direitos sob a legislação aplicável incluem acesso aos dados pessoais seus que
                    processamos, o direito de ter tais dados pessoais corrigidos, apagados ou bloqueados, e o
                    direito de contestar certas atividades de processamento de dados. Para exercer esses direitos,
                    você deve fazer uma solicitação por escrito, usando os dados de contato que fornecemos na
                    sequência.
                        </p><br />
                <b>10. Como entrar em contato conosco</b>
                <p style={{textAlign: 'justify'}}>
                    Se tiver qualquer comentário, pergunta ou dúvida sobre esta Política de Privacidade, se desejar
                    atualizar ou alterar as informações que mantemos a seu respeito ou exercer seus direitos, você
                        pode entrar em contato conosco por meio do e-mail <a href="mailto:administrativo@lekacatalogos.com.br">administrativo@lekacatalogos.com.br</a>.
                            </p><br />

            </div>
        </div>
    );
};

export default PoliticaPrivacidade;